/* osomni-atc.js — v2026-05-03d
 * Custom Add-to-Cart handlers for all custom surfaces (top-picks, collection cards,
 * PDP recommendations, cart-drawer recs). Lives as an external asset so it survives
 * theme apps that strip inline <script> blocks for anonymous visitors.
 *
 * v2026-05-03c: header is inside a JSON section group, so section rendering
 * returns null for individual section IDs. Falls back to fetching the page HTML
 * and extracting the cart drawer + cart icon from it.
 */
(function () {
  if (window._osomniAtcInit) return;
  window._osomniAtcInit = true;

  function applyDrawerFromDoc(doc) {
    var newDialog = doc.querySelector('cart-drawer-component .cart-drawer__dialog');
    var existingDialog = document.querySelector('cart-drawer-component .cart-drawer__dialog');
    if (newDialog && existingDialog) {
      existingDialog.className = newDialog.className;
      var aria = newDialog.getAttribute('aria-labelledby');
      if (aria) existingDialog.setAttribute('aria-labelledby', aria);
      existingDialog.innerHTML = newDialog.innerHTML;
    }
    var newBubble = doc.querySelector('[ref="cartItemCount"]');
    if (newBubble) {
      var newCount = parseInt(newBubble.textContent || '0', 10) || 0;
      document.querySelectorAll('cart-icon').forEach(function (ci) {
        var countEl = ci.querySelector('[ref="cartBubbleCount"]');
        var bubble = ci.querySelector('[ref="cartBubble"]');
        if (countEl) countEl.textContent = newCount < 100 ? String(newCount) : '';
        if (bubble) bubble.classList.toggle('visually-hidden', newCount === 0);
        ci.classList.toggle('header-actions__cart-icon--has-cart', newCount > 0);
        if (countEl) countEl.classList.toggle('hidden', newCount === 0);
      });
    }
    return !!(newDialog && existingDialog);
  }

  function updateCartIconCount(itemCount) {
    document.querySelectorAll('cart-icon').forEach(function (ci) {
      var countEl = ci.querySelector('[ref="cartBubbleCount"]');
      var bubble = ci.querySelector('[ref="cartBubble"]');
      if (countEl) countEl.textContent = itemCount < 100 ? String(itemCount) : '';
      if (bubble) bubble.classList.toggle('visually-hidden', itemCount === 0);
      ci.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
      if (countEl) countEl.classList.toggle('hidden', itemCount === 0);
    });
  }

  /* ─── Helper: replace cart drawer + icon from response.sections, with page-fetch fallback */
  window.osomniSyncCartDrawer = async function (sections) {
    // Try sections data first (fast path; works when section is at template/layout root)
    if (sections) {
      for (var sId in sections) {
        if (!Object.prototype.hasOwnProperty.call(sections, sId)) continue;
        var html = sections[sId];
        if (!html) continue; // null = section is in a section group, fall through
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (applyDrawerFromDoc(doc)) return true;
      }
    }
    // Fallback: fetch the current page with a cache-busting query so we get
    // origin-rendered HTML (which reflects the updated cart cookie), bypassing
    // the stale edge cache.
    try {
      var sep = window.location.search ? '&' : '?';
      var bustUrl =
        window.location.pathname + window.location.search + sep + '_atccb=' + Date.now();
      var pageRes = await fetch(bustUrl, {
        headers: { Accept: 'text/html', 'Cache-Control': 'no-cache' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!pageRes.ok) return false;
      var pageHtml = await pageRes.text();
      var pageDoc = new DOMParser().parseFromString(pageHtml, 'text/html');
      return applyDrawerFromDoc(pageDoc);
    } catch (e) {
      console.error('[osomni-atc] Page-fetch fallback for drawer sync failed:', e);
      return false;
    }
  };

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
      if (c.dataset.sectionId && ids.indexOf(c.dataset.sectionId) === -1) {
        ids.push(c.dataset.sectionId);
      }
    });
    return ids;
  }

  async function performAtc(variantId, quantity) {
    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(quantity || 1));
    var sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });
    if (!res.ok) {
      var errText = await res.text();
      throw new Error('cart/add ' + res.status + ': ' + errText);
    }
    return res.json();
  }

  function dispatchCartUpdate(data, source, variantId) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            sections: data.sections,
            source: source,
            variantId: variantId
          }
        }
      })
    );
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  async function runAtcFlow(btn, source, opts) {
    opts = opts || {};
    if (btn.disabled) return;
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) {
      console.error('[osomni-atc] ' + source + ': missing variantId', btn);
      return;
    }

    var orig = btn.textContent;
    var pendingText = opts.pendingText != null ? opts.pendingText : 'Adding…';
    var doneText = opts.doneText != null ? opts.doneText : '✓ Added';
    btn.textContent = pendingText;
    btn.disabled = true;

    try {
      var data = await performAtc(variantId, 1);
      await window.osomniSyncCartDrawer(data.sections);
      dispatchCartUpdate(data, source, variantId);
      if (opts.openDrawer !== false) openCartDrawer();
      btn.textContent = doneText;
      setTimeout(function () {
        btn.textContent = orig;
        btn.disabled = false;
      }, opts.resetMs || 2000);
    } catch (err) {
      console.error('[osomni-atc] ' + source + ' failed:', err);
      btn.textContent = orig;
      btn.disabled = false;
    }
  }

  /* ─── Card click → PDP (for product-card components that lack a working link) */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('product-card[data-pdp-url]');
    if (!card) return;
    if (e.target.closest('.js-open-product')) return;
    if (e.target.closest('.card-atc-btn')) return;
    if (e.target.closest('.top-picks__atc')) return;
    sessionStorage.setItem('gallery_url', window.location.pathname + window.location.search);
    window.location.href = card.dataset.pdpUrl;
  });

  /* ─── Top Picks (Most Loved on collection page) ─────────────────────────── */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.top-picks__atc');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      runAtcFlow(btn, 'top-picks');
    },
    true
  );

  /* ─── Collection card ATC (.card-atc-btn outside product-recommendations) ─ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-atc-btn');
    if (!btn) return;
    if (btn.closest('.product-recommendations')) return; // handled separately
    runAtcFlow(btn, 'collection-card');
  });

  /* ─── PDP recommendations (.product-recommendations .card-atc-btn) ──────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-recommendations .card-atc-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    runAtcFlow(btn, 'pdp-recommendations');
  });

  /* ─── Cart drawer "+" recs (.cart-rec-item__btn) ────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-rec-item__btn');
    if (!btn) return;
    runAtcFlow(btn, 'cart-rec', {
      pendingText: '✓',
      doneText: '✓',
      openDrawer: false
    });
  });
})();
